import React, {Component, createRef, forwardRef} from 'react';
import classNames from 'classnames';
import FJColorPanelCommon from 'fj-components/FJColorPicker';
import FJDropDown from "fj-components/FJDropDown"
import FJTopToolbarApplyAll from './FJTopToolbarApplyAll'
import './FJColorContainer.less';
import FJLocalStore from "../../../store/FJLocalStore";
import FJUtil from "../../../util/FJUtil";
import FJConfig from "../../../config/FJConfig";

const ForwardTrigger = forwardRef((props, ref) => {
  let {
    triggerContainerCN,
    colorBtnCN,
    triggerBtnBG,
		tips
  } = props;
  return (
    <div ref={ref} className={triggerContainerCN} tooltip={tips}>
      <div style={{background: triggerBtnBG}}
           className={colorBtnCN}/>
    </div>
  );
});

class FJColorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledMouseEvent: true,
    };
    this.subColorPanel = createRef();
    this.dropDown = createRef();
    this.solidColors = FJConfig.solidColors;
    this.doubleColors = FJConfig.doubleColors;
  }

  componentDidMount() {
    FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
		FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
  }

  _updateSubPanelColor = () => {
    this.subColorPanel.current.updateUI(this.props.colorData);
  };
  _colorDataChange = (data) => {
    let {isSolid, colorData, colorDataChange} = this.props;
    if (colorDataChange) {
      let color = isSolid ? {mainColor: data.color, subColor: colorData.subColor} : data.color;
      colorDataChange(data.type, color);
    }
  };
  _disableMouseEvent = (toggle) => {
    this.setState({
      disabledMouseEvent: toggle,
    });
  };

  fitOverlayPosition = () => {
    this.dropDown.current.resizeSensor();
    this.subColorPanel.current.fitOverlayPosition();
  };

  /**
   * @description 设置隐藏
   * @private
   */
  _hideColorPanelActions = () => {
    this.dropDown.current.hide();
  };

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {
    let {documentColors, addDocumentColor, isSolid, applyToAll, deleteColor, colorData, disabled, hasApplyToAll = true, zIndex, tips, useAnchorBody, isTopLayer} = this.props;
    let triggerBtnBG = isSolid ? colorData.mainColor : 'linear-gradient(90deg, ' + colorData.mainColor + ' 50%, ' + colorData.subColor + ' 50%)';
    let triggerContainerCN = classNames('u-tooltip-bottom c-color-btn-container', {disabled: disabled});
    let colorBtnCN = classNames('u-button-cursor c-color-btn', {disabled: disabled});

    const classes = {
      panelClass: 'c-color-picker-panel',
      categoryTitleClass: 'c-color-picker-title',
      addBtnClass: 'c-color-picker-add-btn',
      inputClass: 'c-color-input-box',
      inputTitleClass: 'c-color-input-title'
    };

    return (
      <FJDropDown overlay={
        <div className='c-color-popup-panel-text'>
          <FJColorPanelCommon defaultColors={isSolid ? this.solidColors : this.doubleColors}
                              documentColors={isSolid ? documentColors.solidColors : documentColors.doubleColors}
                              addDocumentColor={addDocumentColor}
                              deleteColor={deleteColor}
                              ref={this.subColorPanel}
                              isSolid={isSolid}
                              disableMouseEvent={this._disableMouseEvent}
                              colorDataChange={this._colorDataChange}

                              documentColorText={FJLocalStore._('document-colors')}
                              solidColorText={FJLocalStore._('solid-colors')}
                              doubleColorText={FJLocalStore._('double-colors')}
                              colorOneText={FJLocalStore._('color-one')}
                              colorTwoText={FJLocalStore._('color-two')}
                              classes={classes}

          />
          {hasApplyToAll ? <FJTopToolbarApplyAll onClick={() => applyToAll(colorData)}/> : null}

        </div>
      }
                  useAnchorBody={useAnchorBody}
                  hasArrow={true}
                  isTopLayer={isTopLayer}
                  couldEventHide={this.state.disabledMouseEvent}
                  onShow={this._updateSubPanelColor}
                  disabled={this.props.disabled}
                  ref={this.dropDown}
                  toggleTooltip={this._toggleTooltip}
									zIndex={zIndex}

      >
        <ForwardTrigger triggerContainerCN={triggerContainerCN}
                        colorBtnCN={colorBtnCN}
                        triggerBtnBG={triggerBtnBG}
												tips={tips}
				/>
      </FJDropDown>
    );
  }
}

export default FJColorContainer;
